let slideIndex = 0;
let slidesPerView = 1;
let slidesPerViewMobile = 1;
let autoplay = false;
let autoplaySpeed = 5000;
let autoplayInterval;
let isTransitioning = false;

// Drag variables
let isDragging = false;
let startPos = 0;
let currentTranslate = 0;
let prevTranslate = 0;
let animationID = 0;

// Initialize slider on page load
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.slideshow-container');
  
  if (container) {
    // Get settings from data attributes
    slidesPerView = parseInt(container.dataset.slidesPerView) || 1;
    slidesPerViewMobile = parseInt(container.dataset.slidesPerViewMobile) || 1;
    autoplay = container.dataset.autoplay === 'true';
    autoplaySpeed = parseInt(container.dataset.autoplaySpeed) * 1000 || 5000;
    
    // Clone slides for infinite loop
    createClones();
    
    showSlides(slideIndex, false);
    
    // Initialize drag functionality
    initDragSlider(container);
    
    // Start autoplay if enabled
    if (autoplay) {
      startAutoplay();
    }
  }
});

// Create clones for infinite scrolling - FIXED to create enough clones
function createClones() {
  const wrapper = document.querySelector('.slides-wrapper');
  const slides = Array.from(document.querySelectorAll('.mySlides'));
  
  if (!wrapper || slides.length === 0) return;
  
  // Calculate how many clones we need (at least 2x the viewport)
  const currentPerView = getCurrentSlidesPerView();
  const clonesNeeded = Math.max(slides.length * 2, currentPerView * 3);
  
  // Clone slides at the beginning (for backwards wrap)
  for (let i = 0; i < clonesNeeded; i++) {
    const clone = slides[i % slides.length].cloneNode(true);
    clone.classList.add('clone');
    wrapper.insertBefore(clone, wrapper.firstChild);
  }
  
  // Clone slides at the end (for forwards wrap)
  for (let i = 0; i < clonesNeeded; i++) {
    const clone = slides[i % slides.length].cloneNode(true);
    clone.classList.add('clone');
    wrapper.appendChild(clone);
  }
  
  // Set initial position to show original slides
  slideIndex = clonesNeeded;
  showSlides(slideIndex, false);
}

// Get current slides per view based on screen size
function getCurrentSlidesPerView() {
  return window.innerWidth <= 768 ? slidesPerViewMobile : slidesPerView;
}

// Calculate centering offset for desktop and mobile
function getCenteringOffset() {
  const container = document.querySelector('.slideshow-container');
  const wrapper = document.querySelector('.slides-wrapper');
  const allSlides = document.querySelectorAll('.mySlides');
  const currentPerView = getCurrentSlidesPerView();
  
  if (!container || !wrapper || !allSlides.length) return 0;
  
  const containerWidth = container.offsetWidth;
  const slideWidth = allSlides[0].offsetWidth;
  
  // Calculate total width of visible slides (no gaps now)
  const totalVisibleWidth = slideWidth * currentPerView;
  
  // Center the visible slides - this creates equal margins on left and right
  const offset = (containerWidth - totalVisibleWidth) / 2;
  
  console.log('Centering calculation:', {
    containerWidth,
    slideWidth,
    currentPerView,
    totalVisibleWidth,
    offset,
    isMobile: window.innerWidth <= 768
  });
  
  return offset;
}

// Next/previous controls - moves by 1 slide
function plusSlides(n) {
  if (isTransitioning) return;
  
  slideIndex += n;
  showSlides(slideIndex, true);
  
  // Reset autoplay timer
  if (autoplay) {
    resetAutoplay();
  }
}

// Thumbnail image controls
function currentSlide(n) {
  if (isTransitioning) return;
  
  const slides = document.querySelectorAll('.mySlides:not(.clone)');
  const allSlides = document.querySelectorAll('.mySlides');
  const wrapper = document.querySelector('.slides-wrapper');
  
  // Count clones at the beginning
  let clonesAtStart = 0;
  for (let i = 0; i < allSlides.length; i++) {
    if (allSlides[i].classList.contains('clone')) {
      clonesAtStart++;
    } else {
      break;
    }
  }
  
  // Adjust for cloned slides offset
  slideIndex = n - 1 + clonesAtStart;
  
  showSlides(slideIndex, true);
  
  // Reset autoplay timer
  if (autoplay) {
    resetAutoplay();
  }
}

function showSlides(n, animate = true) {
  const wrapper = document.querySelector('.slides-wrapper');
  const allSlides = document.querySelectorAll('.mySlides');
  const originalSlides = document.querySelectorAll('.mySlides:not(.clone)');
  const dots = document.getElementsByClassName("dot");
  const currentPerView = getCurrentSlidesPerView();
  
  if (!wrapper || allSlides.length === 0) return;
  
  // Update slideIndex
  slideIndex = n;
  
  // Calculate slide width (gap is now 0)
  const slideWidth = allSlides[0].offsetWidth;
  const centerOffset = getCenteringOffset();
  
  // Calculate the base offset - with gap:0, just multiply by slideWidth
  const baseOffset = -slideWidth * slideIndex;
  const offset = baseOffset + centerOffset;
  
  console.log('showSlides:', {
    slideIndex,
    slideWidth,
    baseOffset,
    centerOffset,
    finalOffset: offset
  });
  
  // Store the offset for drag functionality
  prevTranslate = offset;
  currentTranslate = offset;
  
  // Enable/disable transition
  if (animate) {
    wrapper.style.transition = 'transform 0.5s ease-in-out';
    isTransitioning = true;
  } else {
    wrapper.style.transition = 'none';
    isTransitioning = false;
  }
  
  // Apply transform to move the wrapper
  wrapper.style.transform = `translateX(${offset}px)`;
  
  // Handle wrap-around after transition - FIXED logic
  if (animate) {
    setTimeout(() => {
      // Count clones at the beginning
      let clonesAtStart = 0;
      for (let i = 0; i < allSlides.length; i++) {
        if (allSlides[i].classList.contains('clone')) {
          clonesAtStart++;
        } else {
          break;
        }
      }
      
      const totalOriginal = originalSlides.length;
      const maxIndex = clonesAtStart + totalOriginal;
      
      // If we've moved past the last clone threshold, jump back
      if (slideIndex >= maxIndex) {
        slideIndex = clonesAtStart + (slideIndex - maxIndex);
        showSlides(slideIndex, false);
      }
      // If we've moved before the first clone threshold, jump forward
      else if (slideIndex < clonesAtStart - totalOriginal + currentPerView) {
        slideIndex = maxIndex - totalOriginal + (slideIndex - (clonesAtStart - totalOriginal + currentPerView));
        showSlides(slideIndex, false);
      }
      isTransitioning = false;
    }, 500); // Match transition duration
  }
  
  // Update dots based on actual slide position
  let clonesAtStart = 0;
  for (let i = 0; i < allSlides.length; i++) {
    if (allSlides[i].classList.contains('clone')) {
      clonesAtStart++;
    } else {
      break;
    }
  }
  
  const actualIndex = (slideIndex - clonesAtStart + originalSlides.length) % originalSlides.length;
  
  for (let i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" active", "");
  }
  
  // Highlight dots for visible slides
  for (let i = 0; i < currentPerView; i++) {
    const dotIndex = (actualIndex + i) % originalSlides.length;
    if (dots[dotIndex]) {
      dots[dotIndex].className += " active";
    }
  }
}

// Initialize drag functionality
function initDragSlider(container) {
  const slidesWrapper = container.querySelector('.slides-wrapper');
  
  if (!slidesWrapper) return;

  // Touch events
  slidesWrapper.addEventListener('touchstart', touchStart, { passive: true });
  slidesWrapper.addEventListener('touchend', touchEnd);
  slidesWrapper.addEventListener('touchmove', touchMove, { passive: false });

  // Mouse events
  slidesWrapper.addEventListener('mousedown', touchStart);
  slidesWrapper.addEventListener('mouseup', touchEnd);
  slidesWrapper.addEventListener('mouseleave', touchEnd);
  slidesWrapper.addEventListener('mousemove', touchMove);

  // Prevent click events when dragging
  let dragDistance = 0;
  slidesWrapper.addEventListener('click', function(e) {
    if (dragDistance > 5) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  function touchStart(event) {
    if (isTransitioning) return;
    
    isDragging = true;
    startPos = getPositionX(event);
    dragDistance = 0;
    
    // Get current transform value
    const style = window.getComputedStyle(slidesWrapper);
    const matrix = style.transform;
    if (matrix !== 'none') {
      const values = matrix.split('(')[1].split(')')[0].split(',');
      prevTranslate = parseInt(values[4]) || 0;
      currentTranslate = prevTranslate;
    }
    
    animationID = requestAnimationFrame(animation);
    slidesWrapper.classList.add('dragging');
    
    // Pause autoplay when dragging
    if (autoplay) {
      clearInterval(autoplayInterval);
    }
  }

  function touchEnd() {
    if (!isDragging) return;
    
    isDragging = false;
    cancelAnimationFrame(animationID);
    slidesWrapper.classList.remove('dragging');

    const movedBy = currentTranslate - prevTranslate;
    dragDistance = Math.abs(movedBy);

    // Determine if we should move to next/prev slide (50px threshold)
    if (movedBy < -50 && !isTransitioning) {
      plusSlides(1);
    } else if (movedBy > 50 && !isTransitioning) {
      plusSlides(-1);
    } else {
      // Snap back to current position
      slidesWrapper.style.transition = 'transform 0.3s ease-out';
      slidesWrapper.style.transform = `translateX(${prevTranslate}px)`;
      
      setTimeout(() => {
        slidesWrapper.style.transition = '';
      }, 300);
    }
    
    // Resume autoplay
    if (autoplay) {
      startAutoplay();
    }
  }

  function touchMove(event) {
    if (isDragging && !isTransitioning) {
      const currentPosition = getPositionX(event);
      const diff = currentPosition - startPos;
      currentTranslate = prevTranslate + diff;
      dragDistance = Math.abs(diff);
      
      // Prevent default to avoid scrolling on touch devices
      if (event.type === 'touchmove' && Math.abs(diff) > 10) {
        event.preventDefault();
      }
    }
  }

  function getPositionX(event) {
    return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
  }

  function animation() {
    if (isDragging) {
      slidesWrapper.style.transform = `translateX(${currentTranslate}px)`;
      requestAnimationFrame(animation);
    }
  }
}

// Autoplay functions
function startAutoplay() {
  autoplayInterval = setInterval(function() {
    plusSlides(1);
  }, autoplaySpeed);
}

function resetAutoplay() {
  clearInterval(autoplayInterval);
  startAutoplay();
}

// Handle window resize - FIXED to recalculate properly
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    const allSlides = document.querySelectorAll('.mySlides');
    const originalSlides = document.querySelectorAll('.mySlides:not(.clone)');
    
    // Count clones at the beginning
    let clonesAtStart = 0;
    for (let i = 0; i < allSlides.length; i++) {
      if (allSlides[i].classList.contains('clone')) {
        clonesAtStart++;
      } else {
        break;
      }
    }
    
    const actualIndex = (slideIndex - clonesAtStart + originalSlides.length) % originalSlides.length;
    slideIndex = actualIndex + clonesAtStart;
    showSlides(slideIndex, false);
  }, 250);
});

// Pause autoplay on hover
const container = document.querySelector('.slideshow-container');
if (container) {
  container.addEventListener('mouseenter', function() {
    if (autoplay) {
      clearInterval(autoplayInterval);
    }
  });
  
  container.addEventListener('mouseleave', function() {
    if (autoplay && !isDragging) {
      startAutoplay();
    }
  });
}